import { addToSessionStore, getFromSessionStore, delFromSessionStore } from './sessionStore'

export default class BotEvents {
    constructor() {
        this.config = null;
    }

    init() {
        window.BotServices.Events.subscribe({
            next: ((event) => {
                if(event.RootMenu) {
                    console.log("Listen BotServices Events : ", event );
                    addToSessionStore({item : 'rootMenu'});
                }
            }),
        });
    }
}

